import i18n from "i18next";
import { useContext } from "react";

import { APIContext } from "./APIProvider";
import { fetcher } from "./fetcher";

export const useRequest = () => {
  const { domain } = useContext(APIContext);

  return async <Response extends unknown>(
    path: string,
    init: RequestInit = { method: "GET" }
  ) => {
    const url = [domain, path].join("");

    return fetcher.request<Response>(url, {
      ...init,
      headers: {
        ...init.headers,
        "Accept-Language": i18n.language,
      },
    });
  };
};
